// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const MapComponent = (el) => {
  const ui = {
    el,
    mapSelect: select('.map-component__select', el),
    mapForm: select('.map-component .form', el),
  };

  // console.log(ui);

  const handleLink = () => {
    ui.mapSelect.addEventListener('change', () => {
      const actionURL = ui.mapSelect.value;

      // console.log(actionURL);
      window.location=actionURL;
    })
  }

  const addEvents = () => {
    handleLink();
  }

  const init = () => {
    addEvents();
  };

  init();
};

export default MapComponent;
